<template>
  <section id="footer">
		<div class="container">
			<div class="row">
				<div class="col-lg-8 mx-auto text-center">
					<a href="https://whin.org/">
						<img src="@/assets/footer/whin-white.svg" class="footerLogo" alt="WHIN" />
					</a>
					<p>
						WHIN &nbsp;·&nbsp; Wabash Heartland Innovation Network<br />
						1281 Win Hentschel Boulevard Suite 2161, West Lafayette, IN 47906 &nbsp;·&nbsp;
						<a href="mailto:info@whin.org">info@whin.org</a>
					</p>

					<p class="socials">
						<a href="https://twitter.com/WHINnetwork" target="_new"><img src="@/assets/footer/twitter-teal.svg" class="socialLogo" alt="Twitter" /></a>
						<a href="http://fb.me/WHINnetwork" target="_new"><img src="@/assets/footer/facebook-teal.svg" class="socialLogo" alt="Facebook" /></a>
						<a href="https://www.linkedin.com/company/whin/" target="_new"><img src="@/assets/footer/linkedin-teal.svg" class="socialLogo" alt="LinkedIn" /></a>
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
  export default {
    name: "WhinFooter"
  }
</script>

<style scoped>

#footer {
	background: #222;
	color: #999;
	font-size: 0.85rem;
	padding: 2.5rem 0 2.5rem 0;
	text-align: center;

}
.footerLogo {
	margin-bottom: 0.5rem;
	width: 4rem;
}
#footer span {
	color: #fff;
}
.socialLogo {
	margin: 0 1rem;
	height: 2rem;
}
.socialLogo:hover {
	opacity: 1.0;
	opacity: .5;
}
.countiesNetwork {
	max-width: 200px;
}
.shapes {
	height: 10rem;
	background-image: url("../assets/footer/footershapes.svg");
	background-repeat: no-repeat;
	background-size: 135%;
	background-position: center;
}
</style>